import { combineReducers } from 'redux';

import { default as aboutBusiness } from './aboutBusiness';
import { default as applicationFormUrl } from './applicationFormUrl';
import { default as benefits } from './benefits';
import { default as brand } from './brand';
import { default as categoryId } from './categoryId';
import { default as displayPay } from './displayPay';
import { default as draftProgress } from './draftProgress';
import { default as expiryDate } from './expiryDate';
import { default as flowType } from './flowType';
import { default as isConfidential } from './isConfidential';
import { default as isGuided } from './isGuided';
import { default as jobAdReference } from './jobAdReference';
import { default as jobDescription } from './jobDescription';
import { default as jobLocationId } from './jobLocationId';
import { default as jobSummary } from './jobSummary';
import { default as jobTitle } from './jobTitle';
import { default as keySellingPoint1 } from './keySellingPoint1';
import { default as keySellingPoint2 } from './keySellingPoint2';
import { default as keySellingPoint3 } from './keySellingPoint3';
import { default as linkOutApplyVia } from './linkOutApplyVia';
import { default as listingDate } from './listingDate';
import { default as maxSalary } from './maxSalary';
import { default as minSalary } from './minSalary';
import { default as payType } from './payType';
import { default as paymentOption } from './paymentOption';
import { default as phoneNumber } from './phoneNumber';
import { default as productDisplayName } from './productDisplayName';
import { default as qualifications } from './qualifications';
import { default as questionnaireUrl } from './questionnaireUrl';
import { default as responsibilities } from './responsibilities';
import { default as salaryCurrency } from './salaryCurrency';
import { default as salaryText } from './salaryText';
import { default as selectedProductId } from './selectedProductId';
import { default as sourceProductId } from './sourceProductId';
import { default as subCategoryId } from './subCategoryId';
import { default as suggestedCategoryId } from './suggestedCategoryId';
import { default as videoUrl } from './videoUrl';
import { default as workType } from './workType';

export default combineReducers({
  aboutBusiness,
  applicationFormUrl,
  benefits,
  brand,
  categoryId,
  displayPay,
  draftProgress,
  expiryDate,
  flowType,
  isConfidential,
  isGuided,
  jobAdReference,
  jobDescription,
  jobLocationId,
  jobSummary,
  jobTitle,
  keySellingPoint1,
  keySellingPoint2,
  keySellingPoint3,
  linkOutApplyVia,
  listingDate,
  maxSalary,
  minSalary,
  payType,
  paymentOption,
  phoneNumber,
  productDisplayName,
  qualifications,
  questionnaireUrl,
  responsibilities,
  salaryCurrency,
  salaryText,
  selectedProductId,
  sourceProductId,
  subCategoryId,
  suggestedCategoryId,
  videoUrl,
  workType,
});
